import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { AppRouter } from 'routers/AppRouter';
import ReduxToastr from 'react-redux-toastr';

// import ChatbotApp from 'components/shared/chatbotApp/ChatbotApp'

import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import 'animate.css/animate.css';
import store from 'store/configureStore';
import Modals from 'components/shared/Modals/Modals';
// import { ChatbotToggleButton } from 'components/shared/chatbotToggleButton/ChatbotToggleButton'
import { Footer } from 'components/shared/footer/Footer';
import { ReturnToTop } from 'components/shared/returnToTop/ReturnToTop';

import 'lib/bootstrap/css/bootstrap-grid.min.css';

class App extends Component {
    state = {
        // displayChatbot: false
    };

    // setDisplayChatbot = (e) => {
    //     e.preventDefault()
    //
    //     this.setState( {
    //        displayChatbot: !this.state.displayChatbot
    //     })
    // }

    render() {
        // const {displayChatbot} = this.state
        return (
            <div className="App">
                {/*{displayChatbot && <ChatbotApp />}*/}
                {/*<ChatbotToggleButton updateChatbot={this.setDisplayChatbot}/>*/}

                <Provider store={store}>
                    <ReduxToastr
                        timeOut={4000}
                        newestOnTop={false}
                        preventDuplicates
                        position="top-left"
                        getState={(state) => state.toastr} // This is the default
                        transitionIn="fadeIn"
                        transitionOut="fadeOut"
                        progressBar
                        closeOnToastrClick
                    />
                    <Modals />
                    <AppRouter />
                    <Footer />
                    <ReturnToTop />
                </Provider>
            </div>
        );
    }
}

export default App;
